import DgDownloadSample from "../../../../src/pages/apis/doc-generation/dg-download-sample";
import DgStartModifyingTitle from "../../../../src/pages/apis/doc-generation/dg-start-modifying-pdf.md";
import DgWhyDocTitle from "../../../../src/pages/apis/doc-generation/dg-why-doc-gen-api.md";
import DgKeyFeatures from "../../../../src/pages/apis/doc-generation/dg-key-features.md";
import DgExploreOtherAdobeDoc from "../../../../src/pages/apis/doc-generation/dg-explore-other-adobe-doc.md";
import AwsUipathCarousel from "../../../../src/pages/apis/doc-generation/aws-uipath-carousel.md";
import { MobileOptimize } from "../../../../src/components/mobileOptimize";
import { AdobeMsBlade } from "../../../../src/components/adobeMicrosoftBlade";
import "../../../../src/styles/doc-generation.css";
import { APIPixelRetargeting } from "../../../../src/components/retargetting";
import * as React from 'react';
export default {
  DgDownloadSample,
  DgStartModifyingTitle,
  DgWhyDocTitle,
  DgKeyFeatures,
  DgExploreOtherAdobeDoc,
  AwsUipathCarousel,
  MobileOptimize,
  AdobeMsBlade,
  APIPixelRetargeting,
  React
};